import uploadMutations from "./mutations.js";
import uploadActions from "./actions.js";
import uploadGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            uploadingFilesDataList: [],
            fileUploader: {},
            fileUploadToCloud: {},
            filesStateList: [],
            allJobs: {},
            allJobsToDisplayInPanel: {},
            setCancelledFileUid: [],
            yetToUpload: {},
            inProgress: {}
        };
    },
    mutations: uploadMutations,
    actions: uploadActions,
    getters: uploadGetters,
};